<template>
    <div>
        <div class="scr-body">
            <section class="sec-host">
                <div>
                    <h3>My hosting manager</h3>
                </div>
                <div>
                    <h2>{{hostingManager.name}}</h2>
                    <p>{{hostingManager.job_title}}</p>
                    <div class="host-contacts">
                        <div>
                            <a class="btn-text" :href="'tel:' + hostingManager.phone">
                                <i class="icon-phone"></i>
                                {{hostingManager.phone}}
                            </a>
                        </div>
                        <div>
                            <a class="btn-text" :href="'mailto:' + hostingManager.email">
                                <i class="icon-mail"></i>
                                {{hostingManager.email.length > 15 ? "Send email" : hostingManager.email}}
                            </a>
                        </div>
                    </div>
                </div>
                <img class="host-photo" width="84" src="../assets/momchil-ganchev.jpg" alt />
            </section>
            <br />

            <section>
                <h3>Teams I'm meeting</h3>
                <div class="box-slider" v-for="team in meetingTeams" :key="team.name">
                    <div class="slider-wrapper">
                        <div class="white-box slider-item">
                          <div class="white-box-content">
                            <h2>{{team.name}}</h2>
                            <p>{{team.description}}</p>
                          </div>
                        </div>
                        <!-- TODO: Make these dynamic -->
                        <img src="../assets/images/ba1.jpg" class="slider-item" alt />
                        <img src="../assets/images/ba2.jpg" class="slider-item" alt />
                    </div>
                </div>
                <!-- TODO: Add another page for other teams -->
                <!-- <a href="#" class="btn">
                    <i class="icon-arrow-right"></i> See other DTC Teams
                </a>-->
            </section>

            <br />

            <section>
                <h3>Safety regulations</h3>

                <div class="picture-list">
                    <img width="84" src="../assets/images/badge.svg" />
                    <div>Show your ID at the reception desk to get a temporary badge giving you access to DTC premises</div>
                </div>
                <div class="picture-list">
                    <img width="84" src="../assets/images/host.svg" />
                    <div>Please note that you should tour DTC premises only alongside your host</div>
                </div>
                <div class="picture-list">
                    <img width="84" src="../assets/images/restricted-access.svg" />
                    <div>Your visitors’ badge doesn’t grant you access to restricted areas. You are not allowed in areas such as labs and server rooms</div>
                </div>
                <div class="picture-list">
                    <img width="84" src="../assets/images/return-badge.svg" />
                    <div>Make sure to return your visitors’ badge at the reception desk every evening when you leave the DTC office</div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import mockData from "../store/mockData.json";
// MyVisit component includes information about the hosting manager of the visit.
//It also presents the teams that the visitors will be meeting
export default {
    data() {
        return {
            visitID: this.$store.getters.visitID,
            visit: this.$store.getters.visit,
            teams: mockData.teams
        };
    },
    computed: {
        hostingManager() {
            let hostingManager = null;
            if (this.visit) {
                hostingManager = this.visit.hostingManager;
            }
            return hostingManager;
        },
        meetingTeams() {
            let meetingTeams = [];
            this.teams.forEach(team => {
                if (this.visit.teams.includes(team.name)) {
                    meetingTeams.push(team);
                }
            });
            return meetingTeams;
        }
    },
    methods: {
        /**
         * @vuese
         * Check if there is a visitID already and redirects to 404 page if there is none.
         */
        checkID() {
            if (!this.visitID) {
                this.$router.push("/404");
            }
        },
        getWeather() {
            axios({
                method: "GET",
                url:
                    "https://community-open-weather-map.p.rapidapi.com/forecast/daily",
                headers: {
                    "content-type": "application/octet-stream",
                    "x-rapidapi-host":
                        "community-open-weather-map.p.rapidapi.com",
                    "x-rapidapi-key":
                        "77d2bf7d9bmsh57438dde98532ecp16c7a9jsn8e22c5f6cbb8"
                },
                params: {
                    q: "sofia, bg",
                    cnt: "16",
                    units: "metric"
                }
            }).then(res => {
                this.weather = res.data.list;
            });
        }
    },
    // computed: {
    //     temperature() {
    //         return this.weather.length != 0
    //             ? parseFloat(this.weatherForSelectedDay.temp.day).toFixed(1)
    //             : "";
    //     },
    //     weatherIcon() {
    //         return this.weather.length != 0
    //             ? `http://openweathermap.org/img/wn/${this.weatherForSelectedDay.weather[0].icon}@2x.png`
    //             : "";
    //     },
    //     weatherForSelectedDay() {
    //         let weather = { temp: { day: "-" } };
    //         this.weather.forEach(day => {
    //             if (moment.unix(day.dt).format("DD") === this.selectedDate) {
    //                 weather = day;
    //             }
    //         });
    //         return weather;
    //     }
    // },
    mounted() {
        this.checkID();
        // Fired when the component is ready. <br/> Emitted for the Header to be changed to the correct title.
        // @arg The argument is a `String` value representing the current title.
        this.$emit("changed", "Visit overview");
    }
};
</script>

<style>
</style>
